import { render, staticRenderFns } from "./UsersWrapper.vue?vue&type=template&id=97d8cce4&"
import script from "./UsersWrapper.vue?vue&type=script&lang=ts&"
export * from "./UsersWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./UsersWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports